import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { StrategyHistoryYear } from '@/types';
import { STRATEGY_CHART_COLORS, strategyChartTooltipProps } from './strategy-chart-shared';

export interface StrategyHistoryComparisonChartProps {
  years: StrategyHistoryYear[];
  /** Smaller chart for side panel */
  compact?: boolean;
}

export function StrategyHistoryComparisonChart({ years, compact }: StrategyHistoryComparisonChartProps) {
  if (!years.length) return null;

  const sorted = [...years].sort((a, b) => a.year - b.year);
  const data = sorted.map((y) => ({
    year: String(y.year),
    completion: y.completion_rate,
    budgetUtil: Math.round(y.budget_utilization),
  }));

  const h = compact ? 220 : 300;

  return (
    <div className="w-full" style={{ height: h }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={
            compact
              ? { top: 8, right: 8, left: -8, bottom: 0 }
              : { top: 12, right: 12, left: 0, bottom: 0 }
          }
        >
          <CartesianGrid strokeDasharray="3 3" className="stroke-primary-foreground dark:stroke-muted" />
          <XAxis
            dataKey="year"
            tick={{ fontSize: compact ? 10 : 12 }}
            className="fill-muted "
          />
          <YAxis
            domain={[0, 'auto']}
            tick={{ fontSize: compact ? 10 : 12 }}
            className="fill-muted "
            tickFormatter={(v) => `${v}%`}
            width={compact ? 40 : 48}
          />
          <Tooltip
            {...strategyChartTooltipProps}
            formatter={(value: number, name: string) => [`${value}%`, name]}
            labelFormatter={(l) => `Jahr ${l}`}
          />
          <Legend wrapperStyle={{ fontSize: compact ? 11 : 12 }} />
          <Bar
            dataKey="completion"
            name="Abschlussquote"
            fill={STRATEGY_CHART_COLORS[0]}
            radius={[4, 4, 0, 0]}
            maxBarSize={compact ? 28 : 40}
          />
          <Bar
            dataKey="budgetUtil"
            name="Budget-Auslastung"
            fill={STRATEGY_CHART_COLORS[2]}
            radius={[4, 4, 0, 0]}
            maxBarSize={compact ? 28 : 40}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
